<div class="popup-wrapper">
  <button class="close-btn" (click)="closePopUp()">✕</button>
<mat-card>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
    </ng-container>

    <ng-container matColumnDef="color">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="color-circle" [style.background-color]="element.color"></div>
      </td>
    </ng-container>

    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef>Count</th>
      <td mat-cell *matCellDef="let element">{{ element.number }}</td>
    </ng-container>

     <ng-container matColumnDef="per">
      <th mat-header-cell *matHeaderCellDef>Revenue %</th>
      <td mat-cell *matCellDef="let element">{{ element.per }}%</td>
    </ng-container>

    <ng-container matColumnDef="list">
      <th mat-header-cell *matHeaderCellDef>Product</th>
      <td mat-cell *matCellDef="let element">
        {{ element.list.join(', ') }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-card>
</div>